import React, { useContext, forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { ThemeContext } from "../Theme";
import { Icon } from "../Icon";

import styles from "./TextLink.scss";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const TextLink = forwardRef(
  (
    {
      children,
      href,
      variants,
      customClass,
      iconLeft,
      leftIconProps,
      iconRight,
      rightIconProps,
      ...elementProps
    },
    ref
  ) => {
    const context = useContext(ThemeContext);

    const elementClasses = cx(variants, customClass, {
      [styles.link]: !variants,
      [styles[context]]: context,
    });

    return (
      <a href={href} className={elementClasses} ref={ref} {...elementProps}>
        {iconLeft && (
          <span className={styles["link-icon--left"]}>
            <Icon
              size={Icon.Size.parent}
              icon={iconLeft}
              wrapperProps={leftIconProps}
            />
          </span>
        )}
        {children}
        {iconRight && (
          <span className={styles["link-icon--right"]}>
            <Icon
              size={Icon.Size.parent}
              icon={iconRight}
              wrapperProps={rightIconProps}
            />
          </span>
        )}
      </a>
    );
  }
);

TextLink.propTypes = {
  iconLeft: PropTypes.elementType,
  iconRight: PropTypes.elementType,
  leftIconProps: PropTypes.objectOf(PropTypes.any),
  rightIconProps: PropTypes.objectOf(PropTypes.any),
  href: PropTypes.string,
  variants: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  customClass: PropTypes.string,
};

TextLink.defaultProps = {
  iconLeft: null,
  iconRight: null,
  leftIconProps: {},
  rightIconProps: {},
  href: "#",
  variants: "",
  customClass: undefined,
};

TextLink.Variant = {
  highlight: styles.highlight,
  blackSmall: styles.blackSmall,
  blackMedium: styles.blackMedium,
  blackLarge: styles.blackLarge,
};

TextLink.displayName = "TextLink";

export default TextLink;
